import { render, staticRenderFns } from "./dr-designer-component.vue?vue&type=template&id=7432cc92"
import script from "./dr-designer-component.vue?vue&type=script&lang=js"
export * from "./dr-designer-component.vue?vue&type=script&lang=js"
import style0 from "./dr-designer-component.vue?vue&type=style&index=0&id=7432cc92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports